const jQ = jQuery.noConflict();

class WishlistManage {
    constructor(args) {
        this.addTrigger = args.addTrigger;
        this.headerTrigger = args.headerTrigger;
        this.removeTrigger = args.removeTrigger;
    }
    setActive() {
        const oldItems = JSON.parse(localStorage.getItem('wishListArray')) || [];
        const currentProd = jQ(this.addTrigger);

        if (currentProd.length) {

            const id = currentProd.attr('data-product');
            let exist = false;

            for (let i=0; i < oldItems.length; i++) {
                if (oldItems[i].product_id === id) {
                    exist = true;
                }
            }
            if (exist) {
                currentProd.addClass('in-wishlist');
            }
        }
        if (oldItems.length > 0) {
            jQ(this.headerTrigger).addClass('in-wishlist');
            jQ('.wishlist-empty-wrap').hide();
            let html = '';
            let i;
            for (i = 0; i < oldItems.length; i++) {
                const id = oldItems[i].product_id;
                const url = oldItems[i].product_url;
                const image = oldItems[i].product_image;
                html += '<div class="wishlist-item" data-id="' + id + '">';
                html += '<button class="wishlist-item-remove"></button>';
                html += '<a href="' + url + '">';
                html += '<img src="' + image + '"/>';
                html += '</a></div>';
            }
            jQ('.wishlist-product-grid-scroll').append(html);
        }

    }
    addToWishlist(e) {
        e.preventDefault();

        const url = jQ(this).attr('data-url');
        const img = jQ(this).attr('data-image');
        const id = jQ(this).attr('data-product');
        let exist = false;

        let oldItems = JSON.parse(localStorage.getItem('wishListArray')) || [];

        for (let i=0; i < oldItems.length; i++) {
            if (oldItems[i].product_id === id) {
                exist = true;
            }
        }
        if (exist !== true && !jQ(this).hasClass('in-wishlist')) {
            const newItem = {
                'product_url': url,
                'product_image': img,
                'product_id': id
            };
            oldItems.push(newItem);

            localStorage.setItem('wishListArray', JSON.stringify(oldItems));
            jQ(this).addClass('in-wishlist');
            if (!jQ('.wishlist-trigger').hasClass('in-wishlist')) {
                jQ('.wishlist-trigger').addClass('in-wishlist')
            }
            let html = '';

            html += '<div class="wishlist-item" data-id="' + id + '">';
            html += '<button class="wishlist-item-remove"></button>';
            html += '<a href="' + url + '">';
            html += '<img src="' + img + '"/>';
            html += '</a></div>';

            jQ('.wishlist-product-grid-scroll').append(html);
            const myScroll = new IScroll('.wishlist-product-grid', {
                mouseWheel: true,
                scrollbars: false,
            });
            setTimeout(function(){ myScroll.refresh(); }, 100);
            if (jQ('.wishlist-empty-wrap').is(':visible')) {
                jQ('.wishlist-empty-wrap').hide();
            }
        } else {
            for (let i = 0; i < oldItems.length; i++) {
                if (oldItems[i].product_id === id) {
                    oldItems.splice(i, 1);
                }
            }
            localStorage.setItem('wishListArray', JSON.stringify(oldItems));
            jQ(`.wishlist-item[data-id="${id}"]`).remove();
            if (jQ('.wishlist-product-grid-scroll').children().length === 0) {
                jQ('.wishlist-empty-wrap').show();
                jQ('.add-to-wishlist').removeClass('in-wishlist');
                jQ('.wishlist-trigger').removeClass('in-wishlist');
            } else if( jQ('.add-to-wishlist').attr('data-product') == id) {
                jQ('.add-to-wishlist').removeClass('in-wishlist');
            }
        }
    }
    removeFromWishlist(e) {
        e.preventDefault();
        const id = jQ(this).parent().attr('data-id');
        let oldItems = JSON.parse(localStorage.getItem('wishListArray')) || [];

        for (let i = 0; i < oldItems.length; i++) {
            if (oldItems[i].product_id === id) {
                oldItems.splice(i, 1);
            }
        }
        localStorage.setItem('wishListArray', JSON.stringify(oldItems));
        jQ(this).parent().remove();
        if (jQ('.wishlist-product-grid-scroll').children().length === 0) {
            jQ('.wishlist-empty-wrap').show();
            jQ('.add-to-wishlist').removeClass('in-wishlist');
            jQ('.wishlist-trigger').removeClass('in-wishlist');
        } else if( jQ('.add-to-wishlist').attr('data-product') == id) {
            jQ('.add-to-wishlist').removeClass('in-wishlist');
        }
    }
    bindEvents() {
        jQ(this.addTrigger).on('click', this.addToWishlist );
        jQ('body').on('click', this.removeTrigger, this.removeFromWishlist );
    }
    init() {
        this.setActive();
        this.bindEvents();
    }
}

const args = {
    addTrigger: '.add-to-wishlist',
    headerTrigger: '.wishlist-trigger',
    removeTrigger: '.wishlist-item-remove',
}

const Wishlist = new WishlistManage(args);
export default Wishlist;
